const DRAFT = 'draft';
const LOCKED = 'locked';

export default class ProfitAndLossStatus {
    static get DRAFT() { return DRAFT; }

    static get LOCKED() { return LOCKED; }
}
